import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./ContactSection.css";

const ContactSection = () => {
  // States for the form fields
  const [fullName, setFullName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // State for the Thank You overlay
  const [showThankYou, setShowThankYou] = useState(false);

  // Auto-dismiss overlay after 3 seconds
  useEffect(() => {
    let timer;
    if (showThankYou) {
      timer = setTimeout(() => {
        setShowThankYou(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showThankYou]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFullName("");
    setEmailAddress("");
    setSubject("");
    setMessage("");
    setShowThankYou(true);
  };

  const closeOverlay = () => {
    setShowThankYou(false);
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        {/* Left Column: Heading + Form */}
        <div className="contact-left">
          <span className="small-label">Contact Us</span>
          <h2 className="contact-title">Do you have any question?</h2>
          <p className="contact-description">
            For your ease we will offer anything about setup, repairs and
            maintenance. Here are some preferred choices by many of our
            customers because:
          </p>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                required
                type="text"
                id="fullName"
                placeholder="Full Name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="emailAddress">Email Address</label>
              <input
                required
                type="email"
                id="emailAddress"
                placeholder="Email Address"
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                required
                type="text"
                id="subject"
                placeholder="Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                required
                id="message"
                rows="4"
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            <button type="submit" className="submit-button">
              Submit Now
            </button>
          </form>
        </div>

        {/* Right Column: Info List */}
        <div className="contact-right">
          <div className="info-box">
            <h4>Email</h4>
            <p>support@neridtech.com</p>
          </div>
          <div className="info-box">
            <h4>Contacts</h4>
            <p>+381 61 123 4567</p>
          </div>
          <div className="info-box">
            <h4>Data</h4>
            <p>Saturday &amp; Sunday: 07:30 AM - 6 PM</p>
            <p>Weekdays: 07:00 AM - 8 PM</p>
          </div>
          <div className="info-box">
            <h4>Location</h4>
            <p>Bulevar Vudroa Vilsona 14</p>
            <p>Belgrade 11040, Serbia</p>
          </div>
        </div>
      </div>

      {/* Thank You Popup */}
      <AnimatePresence>
        {showThankYou && (
          <motion.div
            className="thank-you-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeOverlay}
          >
            <motion.div
              className="thank-you-content"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="checkmark-container">
                <motion.svg
                  className="checkmark"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                >
                  <circle cx="26" cy="26" r="25" stroke="#007bff" strokeWidth="2" />
                  <path
                    d="M16 27.5L23 34.5L36 19.5"
                    stroke="#007bff"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </motion.svg>
              </div>
              <h3>Thank you for contacting Us</h3>
              <p>We appreciate your message. We'll get back to you soon!</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default ContactSection;